import React, { FC } from 'react'
import { Button } from 'transfix-ui/components/Button'
import { Card } from 'transfix-ui/components/Card'
import { Box, Typography } from 'transfix-ui/core'

interface BookableShipmentSavedSearchAlertPlaceholderRIAImageProps {
  width?: number
  height?: number
}

const BookableShipmentSavedSearchAlertPlaceholderRIAImage: FC<BookableShipmentSavedSearchAlertPlaceholderRIAImageProps> = ({
  height = 51,
  width = 122,
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 122 51'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.243652 25.3412C0.243652 24.9244 0.581583 24.5864 0.998443 24.5864H14.8496C15.2665 24.5864 15.6044 24.9244 15.6044 25.3412C15.6044 25.7581 15.2665 26.096 14.8496 26.096H0.998443C0.581583 26.096 0.243652 25.7581 0.243652 25.3412Z'
      fill='#D3D9E0'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M26.8151 25.3412C26.8151 24.9244 27.1531 24.5864 27.5699 24.5864H41.3775C41.7944 24.5864 42.1323 24.9244 42.1323 25.3412C42.1323 25.7581 41.7944 26.096 41.3775 26.096H27.5699C27.1531 26.096 26.8151 25.7581 26.8151 25.3412Z'
      fill='#D3D9E0'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M53.3378 25.3412C53.3378 24.9244 53.6758 24.5864 54.0926 24.5864H67.9003C68.3171 24.5864 68.6551 24.9244 68.6551 25.3412C68.6551 25.7581 68.3171 26.096 67.9003 26.096H54.0926C53.6758 26.096 53.3378 25.7581 53.3378 25.3412Z'
      fill='#D3D9E0'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M79.8674 25.3412C79.8674 24.9244 80.2054 24.5864 80.6222 24.5864H94.4734C94.8903 24.5864 95.2282 24.9244 95.2282 25.3412C95.2282 25.7581 94.8903 26.096 94.4734 26.096H80.6222C80.2054 26.096 79.8674 25.7581 79.8674 25.3412Z'
      fill='#D3D9E0'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M106.439 25.3412C106.439 24.9244 106.777 24.5864 107.194 24.5864H121.001C121.418 24.5864 121.756 24.9244 121.756 25.3412C121.756 25.7581 121.418 26.096 121.001 26.096H107.194C106.777 26.096 106.439 25.7581 106.439 25.3412Z'
      fill='#D3D9E0'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.243652 8.56094C0.243652 8.14408 0.581583 7.80615 0.998442 7.80615H120.998C121.415 7.80615 121.753 8.14408 121.753 8.56094C121.753 8.9778 121.415 9.31573 120.998 9.31573H0.998442C0.581583 9.31573 0.243652 8.9778 0.243652 8.56094Z'
      fill='#D3D9E0'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.243652 42.122C0.243652 41.7051 0.581583 41.3672 0.998442 41.3672H120.998C121.415 41.3672 121.753 41.7051 121.753 42.122C121.753 42.5388 121.415 42.8768 120.998 42.8768H0.998442C0.581583 42.8768 0.243652 42.5388 0.243652 42.122Z'
      fill='#D3D9E0'
    />
    <path
      d='M61.0206 49.1825C74.1793 49.1825 84.8464 38.5084 84.8464 25.3412C84.8464 12.1741 74.1793 1.5 61.0206 1.5C47.862 1.5 37.1949 12.1741 37.1949 25.3412C37.1949 38.5084 47.862 49.1825 61.0206 49.1825Z'
      fill='#E0F3FD'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M71.6944 16.6364C72.2314 16.6364 72.6666 17.0717 72.6666 17.6086V23.442C72.6666 23.9789 72.2314 24.4142 71.6944 24.4142H65.8611C65.3241 24.4142 64.8889 23.9789 64.8889 23.442C64.8889 22.905 65.3241 22.4697 65.8611 22.4697H70.7222V17.6086C70.7222 17.0717 71.1575 16.6364 71.6944 16.6364Z'
      fill='#0072B5'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M49.3333 27.3309C49.3333 26.7939 49.7686 26.3586 50.3055 26.3586H56.1389C56.6758 26.3586 57.1111 26.7939 57.1111 27.3309C57.1111 27.8678 56.6758 28.3031 56.1389 28.3031H51.2778V33.1642C51.2778 33.7011 50.8425 34.1364 50.3055 34.1364C49.7686 34.1364 49.3333 33.7011 49.3333 33.1642V27.3309Z'
      fill='#0072B5'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M63.1557 17.9172C61.8936 17.5522 60.5596 17.5128 59.2781 17.8027C57.9967 18.0927 56.8096 18.7025 55.8276 19.5753C54.8455 20.4481 54.1006 21.5555 53.6623 22.7941C53.4832 23.3003 52.9277 23.5654 52.4215 23.3863C51.9153 23.2072 51.6502 22.6516 51.8293 22.1454C52.3772 20.5972 53.3083 19.213 54.5358 18.122C55.7633 17.0309 57.2472 16.2686 58.849 15.9062C60.4508 15.5438 62.1184 15.593 63.696 16.0494C65.2686 16.5042 66.7008 17.3488 67.8599 18.5047L72.3602 22.7335C72.7515 23.1012 72.7706 23.7164 72.4029 24.1077C72.0352 24.499 71.42 24.5182 71.0287 24.1505L66.5176 19.9116C66.5102 19.9046 66.5029 19.8976 66.4957 19.8904C65.5669 18.9611 64.4178 18.2823 63.1557 17.9172ZM49.597 26.6651C49.9647 26.2738 50.58 26.2547 50.9713 26.6224L55.4824 30.8612C55.4898 30.8682 55.4971 30.8753 55.5043 30.8825C56.4331 31.8117 57.5821 32.4906 58.8442 32.8556C60.1063 33.2207 61.4404 33.2601 62.7218 32.9701C64.0033 32.6802 65.1904 32.0704 66.1724 31.1975C67.1544 30.3247 67.8993 29.2173 68.3376 27.9788C68.5167 27.4726 69.0723 27.2074 69.5785 27.3866C70.0847 27.5657 70.3498 28.1212 70.1707 28.6274C69.6228 30.1756 68.6917 31.5599 67.4642 32.6509C66.2366 33.7419 64.7527 34.5042 63.1509 34.8666C61.5491 35.2291 59.8816 35.1798 58.304 34.7235C56.7313 34.2686 55.2991 33.424 54.1401 32.2681L49.6398 28.0394C49.2485 27.6717 49.2293 27.0564 49.597 26.6651Z'
      fill='#0072B5'
    />
  </svg>
)

interface BookableShipmentSavedSearchAlertPlaceholderImageProps {
  width?: number
  height?: number
}

const BookableShipmentSavedSearchAlertPlaceholderImage: FC<BookableShipmentSavedSearchAlertPlaceholderImageProps> = ({
  height = 51,
  width = 122,
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 122 51'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.243652 25.3412C0.243652 24.9244 0.581583 24.5864 0.998443 24.5864H14.8496C15.2665 24.5864 15.6044 24.9244 15.6044 25.3412C15.6044 25.7581 15.2665 26.096 14.8496 26.096H0.998443C0.581583 26.096 0.243652 25.7581 0.243652 25.3412Z'
      fill='#D3D9E0'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M26.8152 25.3412C26.8152 24.9244 27.1531 24.5864 27.57 24.5864H41.3776C41.7945 24.5864 42.1324 24.9244 42.1324 25.3412C42.1324 25.7581 41.7945 26.096 41.3776 26.096H27.57C27.1531 26.096 26.8152 25.7581 26.8152 25.3412Z'
      fill='#D3D9E0'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M53.3379 25.3412C53.3379 24.9244 53.6758 24.5864 54.0927 24.5864H67.9003C68.3172 24.5864 68.6551 24.9244 68.6551 25.3412C68.6551 25.7581 68.3172 26.096 67.9003 26.096H54.0927C53.6758 26.096 53.3379 25.7581 53.3379 25.3412Z'
      fill='#D3D9E0'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M79.8674 25.3412C79.8674 24.9244 80.2054 24.5864 80.6222 24.5864H94.4734C94.8903 24.5864 95.2282 24.9244 95.2282 25.3412C95.2282 25.7581 94.8903 26.096 94.4734 26.096H80.6222C80.2054 26.096 79.8674 25.7581 79.8674 25.3412Z'
      fill='#D3D9E0'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M106.439 25.3412C106.439 24.9244 106.777 24.5864 107.194 24.5864H121.001C121.418 24.5864 121.756 24.9244 121.756 25.3412C121.756 25.7581 121.418 26.096 121.001 26.096H107.194C106.777 26.096 106.439 25.7581 106.439 25.3412Z'
      fill='#D3D9E0'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.243652 8.56094C0.243652 8.14408 0.581583 7.80615 0.998442 7.80615H120.998C121.415 7.80615 121.753 8.14408 121.753 8.56094C121.753 8.9778 121.415 9.31573 120.998 9.31573H0.998442C0.581583 9.31573 0.243652 8.9778 0.243652 8.56094Z'
      fill='#D3D9E0'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.243652 42.1217C0.243652 41.7049 0.581583 41.3669 0.998442 41.3669H120.998C121.415 41.3669 121.753 41.7049 121.753 42.1217C121.753 42.5386 121.415 42.8765 120.998 42.8765H0.998442C0.581583 42.8765 0.243652 42.5386 0.243652 42.1217Z'
      fill='#D3D9E0'
    />
    <path
      d='M61.0206 49.1825C74.1792 49.1825 84.8464 38.5084 84.8464 25.3412C84.8464 12.1741 74.1792 1.5 61.0206 1.5C47.862 1.5 37.1948 12.1741 37.1948 25.3412C37.1948 38.5084 47.862 49.1825 61.0206 49.1825Z'
      fill='#E0F3FD'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M58.5388 33.8475C59.0396 33.557 59.6811 33.7275 59.9716 34.2283C60.0638 34.3871 60.1961 34.519 60.3552 34.6107C60.5144 34.7023 60.6948 34.7506 60.8784 34.7506C61.0621 34.7506 61.2425 34.7023 61.4017 34.6107C61.5608 34.519 61.6931 34.3871 61.7852 34.2283C62.0758 33.7275 62.7172 33.557 63.2181 33.8475C63.7189 34.138 63.8893 34.7795 63.5988 35.2803C63.3224 35.7569 62.9256 36.1525 62.4481 36.4275C61.9707 36.7025 61.4294 36.8472 60.8784 36.8472C60.3275 36.8472 59.7862 36.7025 59.3088 36.4275C58.8313 36.1525 58.4345 35.7569 58.1581 35.2803C57.8675 34.7795 58.038 34.138 58.5388 33.8475Z'
      fill='#0072B5'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M68.6086 25.1532C68.8897 26.4465 69.2829 27.4043 69.6588 28.0934C70.0066 28.7311 70.3453 29.1494 70.5806 29.3977C70.6985 29.5222 70.7912 29.6047 70.847 29.6512C70.8749 29.6745 70.8936 29.6887 70.9017 29.6947L70.9046 29.6969C71.2805 29.9551 71.4468 30.4273 71.3143 30.8647C71.1804 31.3069 70.7729 31.6093 70.311 31.6093H51.4412C50.9793 31.6093 50.5718 31.3069 50.4379 30.8647C50.3054 30.4273 50.4717 29.9551 50.8475 29.6969L50.8505 29.6947C50.8586 29.6887 50.8773 29.6745 50.9052 29.6512C50.961 29.6047 51.0537 29.5222 51.1716 29.3977C51.4069 29.1494 51.7456 28.7311 52.0934 28.0934C52.7861 26.8233 53.5379 24.6407 53.5379 21.1261C53.5379 19.1799 54.311 17.3133 55.6872 15.9372C57.0634 14.561 58.9299 13.7878 60.8761 13.7878C61.6678 13.7878 62.4463 13.9158 63.184 14.1602C62.5791 14.6555 62.0682 15.2613 61.682 15.9468C61.417 15.9056 61.1476 15.8845 60.8761 15.8845C59.4859 15.8845 58.1527 16.4367 57.1697 17.4197C56.1867 18.4027 55.6345 19.7359 55.6345 21.1261C55.6345 24.9497 54.8137 27.4845 53.934 29.0974C53.8542 29.2436 53.7742 29.3819 53.6944 29.5126H68.0578C67.978 29.3819 67.898 29.2436 67.8182 29.0974C67.3074 28.161 66.8165 26.9137 66.4946 25.2839C66.7152 25.3074 66.9392 25.3194 67.166 25.3194C67.6624 25.3194 68.1454 25.2619 68.6086 25.1532Z'
      fill='#0072B5'
    />
    <path
      d='M71.3585 19.0295C71.3585 21.3453 69.4811 23.2227 67.1652 23.2227C64.8493 23.2227 62.9719 21.3453 62.9719 19.0295C62.9719 16.7136 64.8493 14.8362 67.1652 14.8362C69.4811 14.8362 71.3585 16.7136 71.3585 19.0295Z'
      fill='#0072B5'
    />
  </svg>
)

interface BookableShipmentSavedSearchAlertPlaceholderProps {
  message: string
  subMessage?: string
  isEmailReminderVisible?: boolean
  iconVariant?: 'default' | 'runItAgain'
  btnText?: string
  ctaBtnAction?: () => void
}

export const BookableShipmentSavedSearchAlertPlaceholder: FC<BookableShipmentSavedSearchAlertPlaceholderProps> = ({
  btnText,
  ctaBtnAction,
  iconVariant,
  isEmailReminderVisible = true,
  message,
  subMessage = 'We’ll send you an email as loads become available.',
}) => {
  const icon =
    iconVariant === 'default' || !iconVariant ? (
      <BookableShipmentSavedSearchAlertPlaceholderImage />
    ) : (
      <BookableShipmentSavedSearchAlertPlaceholderRIAImage />
    )

  return (
    <Card>
      <Box display='flex' flexDirection='column' alignItems='center'>
        <Box my={1}>{icon}</Box>
        <Box className='tc' my={1}>
          <Typography color='textSecondary' variant='subtitle1'>
            {message}
          </Typography>
          {isEmailReminderVisible && (
            <Typography color='textSecondary' variant='subtitle2'>
              {subMessage}
            </Typography>
          )}
          {btnText && (
            <Box pt={2}>
              <Button variant='text' color='tertiary' size='large' onClick={ctaBtnAction}>
                {btnText}
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    </Card>
  )
}
